import React, {Component} from 'react';
import {connect} from 'react-redux';
import pick from 'lodash.pick';

import {Col, Collapse, Row} from "reactstrap";
import {Field, formValueSelector, reduxForm} from "redux-form";
import {BoolButtonsField, DateField, InputField, SelectField} from "../../../../../validation/ReduxFormInput";
import {states} from "../../../../../util/FormConstants";
import moment from "moment";
import {handleSubmitVehicle} from "../../../actions/application";

class VehicleForm extends Component {
    render() {
        const {skip_vehicle, has_vehicle, handleSubmit} = this.props;

        return (
            <form onSubmit={handleSubmit}>
                <h4>Drivers License Info</h4>
                <Row>
                    <Col xs={12} sm={4}>
                        <Field name="drivers_license_state" label="State" component={SelectField} options={states}/>
                    </Col>
                    <Col xs={12} sm={4}>
                        <Field name="drivers_license_number" label="ID Number" component={InputField} type="text"/>
                    </Col>
                    <Col xs={12} sm={4}>
                        <Field name="drivers_license_expiration"
                               label="Expiration Date"
                               component={DateField}/>
                    </Col>
                </Row>
                <hr/>
                <Row>
                    <Col>
                        <Field name="skip_vehicle"
                               label="Do you have a car?"
                               component={BoolButtonsField}
                               parse={(value) => {
                                   return !value;
                               }}
                               defaultValue={has_vehicle}/>
                    </Col>
                </Row>
                <Collapse isOpen={!skip_vehicle}>
                    <Row>
                        <Col xs={12} sm={4}><Field name="vehicle.make" label="Make" component={InputField} type="text"/></Col>
                        <Col xs={12} sm={4}><Field name="vehicle.model" label="Model" component={InputField} type="text"/></Col>
                        <Col xs={12} sm={4}><Field name="vehicle.year" label="Year" component={InputField} type="number"/></Col>
                    </Row>
                    <Row>
                        <Col xs={12} sm={6}><Field name="vehicle.license_plate_number" label="License Plate #" component={InputField} type="text"/></Col>
                        <Col xs={12} sm={6}><Field name="vehicle.color" label="Color" component={InputField} type="text"/></Col>
                    </Row>
                </Collapse>
            </form>
        );
    }
}

const validate = values => {
    const errors = {};

    (!values.drivers_license_state || values.drivers_license_state === 'default') && (errors.drivers_license_state = 'Required');
    !values.drivers_license_number && (errors.drivers_license_number = 'Required');
    !values.drivers_license_expiration && (errors.drivers_license_expiration = 'Required');
    values.skip_vehicle === null && (errors.skip_vehicle = 'Required');


    (values.drivers_license_expiration && values.drivers_license_expiration.isBefore(moment())) && (errors.drivers_license_expiration = "Your drivers license is expired");
    if (!values.skip_vehicle && values.vehicle) {
        errors.vehicle = {};
        !values.vehicle.make && (errors.vehicle.make = 'Required');
        !values.vehicle.model && (errors.vehicle.model = 'Required');
        !values.vehicle.year && (errors.vehicle.year = 'Required');

        (!!values.vehicle.year && values.vehicle.year < 1900) && (errors.vehicle.year = 'Must be greater than 1900');

        !values.vehicle.license_plate_number && (errors.vehicle.license_plate_number = 'Required');
        !values.vehicle.color && (errors.vehicle.color = 'Required');

        if (Object.keys(errors.vehicle).length === 0) {
            delete errors.vehicle;
        }
    }

    return errors;
};

const submit = (data, dispatch) => {
    return dispatch(handleSubmitVehicle(Object.assign({}, data, {
        vehicle: data.skip_vehicle ? null : data.vehicle
    })));
};

VehicleForm = reduxForm({
    form: 'application_vehicle',
    onSubmit: submit,
    validate,

})(VehicleForm);

const mapStateToProps = (state) => {
    const selector = formValueSelector('application_vehicle');

    let initial = Object.assign({}, pick(state.tenant.application, [
            'drivers_license_state',
            'drivers_license_number',
            'drivers_license_expiration',
            'skip_vehicle',
            'vehicle'
        ]
    ));

    initial.drivers_license_expiration && (initial.drivers_license_expiration = moment(initial.drivers_license_expiration));

    return {
        skip_vehicle: selector(state, 'skip_vehicle'),
        has_vehicle: !state.tenant.application.skip_vehicle,
        drivers_license_expiration: state.tenant.application.drivers_license_expiration,
        is_vehicle_complete: state.tenant.application.is_vehicle_complete,
        initialValues: initial
    };
};

export default connect(mapStateToProps)(VehicleForm);


// WEBPACK FOOTER //
// ./src/containers/tenant/application/frames/forms/VehicleForm.js